import { motion } from "framer-motion";
import { WHY_POINTS } from "@/data/content";

export default function WhyChoose() {
  return (
    <section data-testid="why-section" className="relative py-32 lg:py-44 px-6 lg:px-24">
      <div className="max-w-[1600px] mx-auto">
        <div className="mb-16 lg:mb-24 max-w-3xl">
          <p className="font-mono text-[10px] tracking-[0.35em] text-goldw uppercase mb-6">Chapter 06 — Why AMAA</p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-ivory leading-[1.05]" data-testid="why-headline">
            The Difference Is<br /><span className="italic text-goldw">in the Details</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-white/8">
          {WHY_POINTS.map((w, i) => (
            <motion.div
              key={w.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.08 }}
              data-testid={`why-point-${i}`}
              className="group border-r border-b border-white/8 p-8 lg:p-10 hover:bg-white/[0.02] transition-colors duration-500"
            >
              <span className="font-mono text-[10px] text-goldw/60 tracking-[0.2em]">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="mt-4 font-serif font-light text-xl sm:text-2xl text-ivory group-hover:text-goldw transition-colors duration-500">
                {w.title}
              </h3>
              <p className="mt-3 text-sm text-zinc2 leading-relaxed">{w.copy}</p>
            </motion.div>
          ))}
          <div className="border-r border-b border-white/8 p-8 lg:p-10 flex flex-col justify-between bg-card/40">
            <p className="font-serif italic font-light text-2xl text-ivory/80 leading-snug">
              “A home should feel inevitable — every line earning its place.”
            </p>
            <span className="mt-6 font-mono text-[9px] tracking-[0.25em] uppercase text-zinc3">AMAA Design &amp; Build</span>
          </div>
        </div>
      </div>
    </section>
  );
}
